import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import SelectedServicePill from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/SelectedServicePill'
import SuggestedServicePill from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/SuggestedServicePill'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@/components/ui/input-group'
import { faSearch } from '@/lib/fontAwesomePro/solid'
import { CompanyServiceCollectionItem } from '@/types/responses/companies'

interface Props {
  searchTerm: string
  onChange: (newSearchTerm: string) => void
  selectedServices: CompanyServiceCollectionItem[]
  otherServicesString: string
}

const ServicesSearchForm: React.FC<Props> = ({
  searchTerm,
  onChange,
  selectedServices,
  otherServicesString,
}) => {
  return (
    <div className="self-stretch">
      <InputGroup>
        <InputGroupAddon>
          <FontAwesomeIcon icon={faSearch} />
        </InputGroupAddon>

        <InputGroupInput
          type="search"
          value={searchTerm}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search all services"
          spellCheck
        />
      </InputGroup>

      <div
        className="mt-2 flex flex-wrap items-center justify-start gap-1
          self-stretch"
      >
        <span>
          {selectedServices.length === 0 &&
          otherServicesString.trim().length === 0
            ? ' '
            : 'Your selected services:'}
        </span>

        {otherServicesString
          .trim()
          .split(',')
          // Because an empty string still returns one empty part
          .filter((part) => part !== '')
          .map((otherServiceName) => (
            <SuggestedServicePill
              key={otherServiceName}
              currentOtherServicesString={otherServicesString}
              suggestedServiceName={otherServiceName}
            />
          ))}

        {selectedServices.map((service: CompanyServiceCollectionItem) => (
          <SelectedServicePill key={service.id} service={service} />
        ))}
      </div>
    </div>
  )
}

export default ServicesSearchForm
